import React from 'react';
import { MapPin, Phone, Mail, Instagram, Heart } from 'lucide-react';
import { engineerInfo, serviceAreas } from '../../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#073A40] text-white">
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          <div>
            <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-[#A69076]">
              {engineerInfo.name}
            </h3>
            <p className="text-[#F2F2F2] text-base leading-relaxed mb-4">
              Engenheira Civil com CREA RN ativo. Especialista em Projetos Técnicos e 
              Regularização de Imóveis no Rio Grande do Norte.
            </p>
            <div className="flex items-center space-x-3">
              <a 
                href={engineerInfo.instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#A69076] rounded-full flex items-center justify-center hover:bg-[#A69F97] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-[#A69076]">Serviços</h4>
            <ul className="space-y-2 text-sm text-[#F2F2F2]">
              <li>Projetos Arquitetônicos</li>
              <li>Projetos Estruturais</li>
              <li>Projetos em 3D</li>
              <li>Regularização de Imóveis</li>
              <li>Laudos Técnicos</li>
              <li>Vistorias e Avaliações</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-[#A69076]">Áreas de Atendimento</h4>
            <div className="flex items-start space-x-2 mb-3">
              <MapPin className="text-[#A69076] flex-shrink-0 mt-0.5" size={18} />
              <div>
                <p className="text-sm text-[#F2F2F2] font-semibold mb-2">Rio Grande do Norte</p>
                <ul className="space-y-1 text-sm text-[#F2F2F2]">
                  {serviceAreas.map((city, index) => (
                    <li key={index}>• {city}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-[#A69076]">Contato</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <Phone className="text-[#A69076] flex-shrink-0 mt-0.5" size={18} />
                <a 
                  href={engineerInfo.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#F2F2F2] hover:text-[#A69076] transition-colors"
                >
                  {engineerInfo.whatsapp}
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="text-[#A69076] flex-shrink-0 mt-0.5" size={18} />
                <a 
                  href={`mailto:${engineerInfo.email}`}
                  className="text-[#F2F2F2] hover:text-[#A69076] transition-colors break-all"
                >
                  {engineerInfo.email}
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Instagram className="text-[#A69076] flex-shrink-0 mt-0.5" size={18} />
                <a 
                  href={engineerInfo.instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#F2F2F2] hover:text-[#A69076] transition-colors"
                >
                  {engineerInfo.instagram}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#A69F97]/30 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-6 mb-6">
            <div className="flex flex-wrap items-center justify-center gap-4">
              <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-lg">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z" fill="#4CAF50"/>
                  <path d="M10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z" fill="white"/>
                </svg>
                <span className="text-sm font-semibold text-white">Site Seguro</span>
              </div>
              
              <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-lg">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="11" width="18" height="11" rx="2" fill="#2196F3"/>
                  <path d="M7 11V7C7 4.79 8.79 3 11 3H13C15.21 3 17 4.79 17 7V11" stroke="#2196F3" strokeWidth="2"/>
                  <circle cx="12" cy="16" r="1.5" fill="white"/>
                </svg>
                <span className="text-sm font-semibold text-white">SSL Certificado</span>
              </div>
              
              <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-lg">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" fill="#FFC107"/>
                  <path d="M12 6C11.45 6 11 6.45 11 7V13C11 13.55 11.45 14 12 14C12.55 14 13 13.55 13 13V7C13 6.45 12.55 6 12 6Z" fill="white"/>
                  <circle cx="12" cy="17" r="1" fill="white"/>
                </svg>
                <span className="text-sm font-semibold text-white">CREA Ativo</span>
              </div>
              
              <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-lg">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#FBBC04"/>
                </svg>
                <span className="text-sm font-semibold text-white">5.0 Estrelas</span>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-[#F2F2F2]">
            <p>
              © {currentYear} {engineerInfo.name}. Todos os direitos reservados.
            </p>
            <p className="flex items-center gap-2">
              Desenvolvido com <Heart size={16} className="text-[#A69076] fill-[#A69076]" /> 
              para construir sonhos
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
